module.exports = "<ul class=\"tag-list\" *ngIf=\"tags\">\r\n  <li *ngFor=\"let tag of tags\" (click)=\"toggleTag(tag)\"><app-single-tag [selected]=\"selectedTags.indexOf(tag) > -1\" [tag]=\"tag\"></app-single-tag></li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/tag-list/tag-list.component.html
// module id = ./src/app/tags/tag-list/tag-list.component.html
// module chunks = main